import type {ReactNode} from 'react'
import {AnimatePresence, motion} from 'framer-motion'
// Styles
import styles from './animation-linear-fade.module.scss'

const variants = {
  enter: (direction: number) => {
    return {
      y: direction > 0 ? 100 : -100,
      opacity: 0,
      transition: {duration: 0.3},
    }
  },
  center: {
    zIndex: 1,
    y: 0,
    opacity: 1,
    transition: {duration: 0.3},
  },
  exit: (direction: number) => {
    return {
      zIndex: 0,
      y: direction < 0 ? 100 : -100,
      opacity: 0,
      transition: {duration: 0.3},
    }
  },
}

interface LinearFadeProps {
  children: ReactNode
  currentIndex: number
  direction: number
  isShowingInterstitialAd: boolean
}

const LinearFade = ({
  children,
  currentIndex,
  direction,
  isShowingInterstitialAd,
}: LinearFadeProps) => {
  return (
    <AnimatePresence
      initial={false}
      custom={direction}
    >
      <motion.div
        key={currentIndex}
        custom={direction}
        variants={variants}
        initial='enter'
        animate='center'
        exit='exit'
        transition={{
          y: {type: 'spring', stiffness: 300, damping: 200},
          opacity: {duration: 0.2},
        }}
        className={`
          ${styles['animation-container']}
          ${isShowingInterstitialAd ? styles['--is-showing-interstitial-ad'] : ''}
          ${styles['--is-photo-voting']}
        `}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  )
}

export default LinearFade
